import { createSelector } from 'reselect'
import wasLikedVariantSelector from 'modules/variant/redux/selectors/was-liked-variant'
import wasDislikedSampleSelector from 'modules/variant/redux/selectors/was-disliked-sample'

/**
 * @param {number} variantId
 * @returns {boolean}
 */
const shouldShowEditRatingSelector = variantId => createSelector(
  wasLikedVariantSelector(variantId),
  wasDislikedSampleSelector(variantId),
  (wasLiked, wasDisliked) => wasLiked || wasDisliked
)

export default shouldShowEditRatingSelector
